import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import {
    OsApiAuthInterceptor,
    OsApiAuthModule,
    TRANSLATION_FILES,
    TrackingModule,
    TranslateInterceptor,
    TranslationService,
} from '@os-components';
import { environment } from '../environments/environment';
import { routes } from './app-routing.module';
import { IS_PREVIEW_TOKEN } from './services/blog/blog.service';

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection(),
        provideAnimations(),
        provideRouter(routes),
        importProvidersFrom(
            TrackingModule.forRoot({
                appName: 'BLOG',
                events: { step: { init: 'INIT' } },
            }),
            TranslateModule.forRoot({
                defaultLanguage: environment.defaultLang,
                loader: {
                    provide: TranslateLoader,
                    useClass: TranslationService,
                },
            }),
            OsApiAuthModule.forRoot(
                {
                    xCsrfTokenUrl: `${environment.baseURLs.api.domain}${environment.baseURLs.api.token}`,
                },
                [
                    {
                        path: '/translate',
                        apiUrl: `${environment.baseURLs.api.domain}${environment.baseURLs.api.translation}`,
                        useXCsrfToken: false,
                        withCredentials: false,
                    },
                    {
                        path: '/caas',
                        apiUrl: environment.caas.baseUrl,
                        useXCsrfToken: false,
                        withCredentials: false,
                    },
                    {
                        path: '/servlet',
                        apiUrl: `${environment.baseURLs.api.domain}${environment.baseURLs.api.mwfServlet}`,
                        useXCsrfToken: false,
                        withCredentials: false,
                    },
                ]
            )
        ),
        { provide: IS_PREVIEW_TOKEN, useValue: environment.preview },
        UntypedFormBuilder,
        provideHttpClient(withInterceptorsFromDi()),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: OsApiAuthInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TranslateInterceptor,
            multi: true,
        },
        TranslationService,
        { provide: TRANSLATION_FILES, useValue: ['BLOG'] },
    ],
};
